import {api} from '@moveup/app-core';

require('json.date-extensions');

const axiosJSONDateParseParams = {
    transformResponse: data => JSON.parseWithDate(data),
};

const initialState = {};

const store = {
    state: initialState,
    mutations: {},
    getters: {},
    actions: {
        getReport(_, params) {
            let regularParams = {
                timezone: params.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
            };
            if(params?.language){
                regularParams.language = params.language;
            }
            return api.get(`report/${params.patientId}/${params.coupleId}`, regularParams);
        },

        getReportPDF(_, params) {
            let regularParams = {
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            };
            if(params?.language){
                regularParams.language = params.language;
            }
            return api.get(`report/${params.patientId}/${params.coupleId}/pdf`, regularParams, {
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                },
            });
        },
    },
};

export default store;
